import React, { useState, useEffect } from 'react';
import './App.css';

const FontPreview = ({ font }) => (
  <div className="font-preview" style={{ fontFamily: font }}>
    <h3>Anteprima font:</h3>
    <p>"Il caffè è il balsamo del cuore e dello spirito."  Giuseppe Verdi</p>
  </div>
);

const CardCreator = () => {
  const [cardData, setCardData] = useState({
    clientName: '',
    clientEmail: '',
    coffeeCount: 10,
    cardColor: '#ffffff',
    textColor: '#000000',
    font: 'Arial',
    logo: null
  });
  const [googleFonts, setGoogleFonts] = useState([]);

  useEffect(() => {
    // Carica i Google Fonts
    fetch('https://www.googleapis.com/webfonts/v1/webfonts?key=YOUR_API_KEY')
      .then(response => response.json())
      .then(data => {
        setGoogleFonts(data.items.slice(0, 200)); // Limita a 20 font per esempio
      })
      .catch(error => console.error('Error loading Google Fonts:', error));
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    setCardData(prev => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Card data:', cardData);
  };

  return (
    <div className="card-creator">
      <h2>Create Loyalty Card</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="clientName">Nome cliente</label>
          <input
            id="clientName"
            name="clientName"
            value={cardData.clientName}
            onChange={handleInputChange}
            placeholder="Client Name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="clientEmail">Email cliente</label>
          <input
            id="clientEmail"
            name="clientEmail"
            value={cardData.clientEmail}
            onChange={handleInputChange}
            placeholder="Client Email"
          />
        </div>
        <div className="form-group">
          <label htmlFor="coffeeCount">Caffè residui</label>
          <input
            id="coffeeCount"
            name="coffeeCount"
            type="number"
            value={cardData.coffeeCount}
            onChange={handleInputChange}
            placeholder="Caffè acquistati"
          />
        </div>
        <div className="form-group">
          <label htmlFor="cardColor">Colore card</label>
          <input
            id="cardColor"
            name="cardColor"
            type="color"
            value={cardData.cardColor}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="textColor">Colore testo</label>
          <input
            id="textColor"
            name="textColor"
            type="color"
            value={cardData.textColor}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="font">Scegli il Font</label>
          <select
            id="font"
            name="font"
            value={cardData.font}
            onChange={handleInputChange}
          >
            <optgroup label="System Fonts">
              <option value="Arial">Arial</option>
              <option value="Helvetica">Helvetica</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier">Courier</option>
              <option value="Verdana">Verdana</option>
              <option value="Georgia">Georgia</option>
              <option value="Palatino">Palatino</option>
              <option value="Garamond">Garamond</option>
              <option value="Bookman">Bookman</option>
              <option value="Comic Sans MS">Comic Sans MS</option>
              <option value="Trebuchet MS">Trebuchet MS</option>
              <option value="Arial Black">Arial Black</option>
            </optgroup>
            <optgroup label="Google Fonts">
              {googleFonts.map(font => (
                <option key={font.family} value={font.family}>
                  {font.family}
                </option>
              ))}
            </optgroup>
          </select>
        </div>
        <FontPreview font={cardData.font} />
        <div className="form-group">
          <label htmlFor="logo">Logo Aziendale</label>
          <input
            id="logo"
            name="logo"
            type="file"
            onChange={handleInputChange}
            accept="image/*"
          />
        </div>
        <button type="submit">Genera nuova Card</button>
      </form>
    </div>
  );
};

export default function App() {
  return <CardCreator />;
}